import { useState } from 'react';
import { Edit, MoreVertical, Trash2 } from 'lucide-react';
import { NConfirmAlert, NDialog, NMenu, NMenuItem } from 'nayan';
import { useDeleteCategoryMutation } from '../../services/ImagesService';
import DrawingsNew from './DrawingsNew.tsx';
import { useDeleteDrawingMutation } from '../../services/DrawingsService.ts';

interface Props {
  drawing: any;
}

const DrawingItemMenu = (props: Props) => {
  const { drawing } = props;
  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const deleteDrawingMutation = useDeleteDrawingMutation();

  return (
    <span className="cursor-pointer" onClick={e => e.stopPropagation()}>
      <NConfirmAlert
        isOpen={showAlert}
        message="This action will delete permanently, Are you sure to delete this drawing?"
        onResult={(result: any) => result && deleteDrawingMutation.mutate(drawing.uuid)}
        onClose={() => setShowAlert(false)}
      />
      <NDialog title="Edit Drawing" isOpen={showModal} onClose={() => setShowModal(false)}>
        <DrawingsNew drawing={drawing} closeModal={() => setShowModal(false)} />
      </NDialog>
      <NMenu trigger={<MoreVertical className="text-text w-4 h-4" />}>
        <NMenuItem title="Edit" icon={Edit} onClick={() => setShowModal(true)} />
        <NMenuItem title="Delete" icon={Trash2} onClick={() => setShowAlert(true)} />
      </NMenu>
    </span>
  );
};

export default DrawingItemMenu;
